var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "scroll-dashboard-div dashboard-container content-wrappper",
      on: { scroll: _vm.deactivatePopover },
    },
    [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("summary-card", {
            attrs: {
              widgetTrackplusFlag: _vm.widgetTrackplusFlag,
              registrationCount: _vm.registrationCount,
              devicesCount: _vm.devicesCount,
              countriesCount: _vm.countriesCount,
            },
          }),
          _c("expiration-card", {
            attrs: {
              widgetTrackplusFlag: _vm.widgetTrackplusFlag,
              expiration_details: _vm.expiration_details,
              expiryVisible: _vm.expiryVisible,
              openPopover: _vm.openPopover,
            },
            on: { viewRegistration: _vm.viewRegistration },
          }),
          _c("pending-card", {
            attrs: {
              widgetTrackplusFlag: _vm.widgetTrackplusFlag,
              pending_summary: _vm.pending_summary,
              pendingVisible: _vm.pendingVisible,
              openPopover: _vm.openPopover,
            },
            on: { viewRegistration: _vm.viewRegistration },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "row MT-25" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-md-12 col-lg-12 p-15" },
          [
            _c("new-map-view", {
              attrs: { roleId: _vm.roleId, permissions: _vm.permissions },
              on: {
                setMapData: _vm.setMapData,
                viewRegistration: _vm.viewRegistration,
                exportDocumentId: _vm.exportPopup,
              },
            }),
            _c("registration-details-popup", {
              attrs: {
                permissions: _vm.permissions,
                dataRow: _vm.activeRegistration,
                reportFlag: true,
              },
              on: { hidePopup: _vm.hidePopup },
            }),
          ],
          1
        ),
      ]),
      _c("permission-access-modal"),
      _c("export-popup", {
        attrs: { documentId: _vm.documentId, mapData: _vm.mapData },
        on: { resetExportPopup: _vm.resetExportPopup },
      }),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }